// extracted by css-extract-rspack-plugin
export default {"dashboardTabs":"EiKTe","createTabButton":"_Dn1O"};